/**
 * Or des étoiles. Une échelle d'étoiles ne gradue pas ses couleurs : on y compte les étoiles
 * désignées, la teinte de chacune ne dit rien de plus — elles sont donc toutes de la même.
 */
export const STAR_COLOR = '#faad14';
